import { FC, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import {
  generateUserLogs,
  getUserById,
} from "../../../services/users.service";
import { IUser } from "../../../models";
import { PulseLoader } from "react-spinners";
import { UserGoal, UserInfo, UserStats } from "../../../widgets";
import { ArrowLineIcon } from "../../../assets";
import { Button } from "../../../components";

const UserProfile: FC = (): JSX.Element => {
  const navigation = useNavigate();
  const params = useParams();

  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [userProfile, setUserProfile] = useState<IUser>();
  const [isLoadingGenerateLogs, setIsLoadingGenerateLogs] = useState(false);

  const onGetUserProfile = async (id: string) => {
    try {
      setIsLoadingProfile(true);
      const { data } = await getUserById(id);
      if (data?.data) {
        setUserProfile(data?.data);
      }
    } catch (error) {
      toast.error(error?.message?.[0]?.message || "Something went wrong");
    } finally {
      setIsLoadingProfile(false);
    }
  };

  const onGenerateUserLogs = async (id: number) => {
    try {
      setIsLoadingGenerateLogs(true);

      const { data } = await generateUserLogs(id);
      if (data?.message === "Ok") {
        toast.success("Logs were successfully generated");
      }
    } catch (error) {
      toast.error(error?.message?.[0]?.message || "Something went wrong");
    } finally {
      setIsLoadingGenerateLogs(false);
    }
  };

  useEffect(() => {
    if (params?.id) {
      onGetUserProfile(params.id);
    }
  }, [params?.id]);

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <ArrowLineIcon
          onClick={() => navigation(-1)}
          className={styles.headerArrowButton}
        />
        <h5 className={styles.headerTitle}>User Profile</h5>
        <div className={styles.headerButtonsContainer}>
          <Button
            title={"Generate Logs"}
            styleType={"disabled"}
            size="small"
            customStyles={styles.generateLogButton}
            loading={isLoadingGenerateLogs}
            onClick={() => onGenerateUserLogs(userProfile?.id || 0)}
          />
        </div>
      </header>
      {isLoadingProfile || !userProfile ? (
        <div className={styles.loaderWrapper}>
          <PulseLoader color={"#7D4AFB"} />
        </div>
      ) : (
        <>
          <UserInfo user={userProfile} />
          <UserGoal user={userProfile} />
          <UserStats user={userProfile} />
        </>
      )}
    </div>
  );
};

export default UserProfile;
